import { Container, IDisposable } from '@cgs/wge';
import { IIconModel } from '../../reels_engine/i_icon_model';
import { IconModel } from './icon_model';

interface IconModelComponentParams {
  animOnStart?: boolean;
}

export class IconModelComponent implements IDisposable {
  public readonly iconModel: IIconModel;

  constructor(container: Container, params?: IconModelComponentParams) {
    console.log('load ' + this.constructor.name);
    this.iconModel = new IconModel(container, !!params?.animOnStart);
  }

  public dispose(): void {
    this.iconModel.dispose();
  }
}
